import TagIcon from '@mui/icons-material/Tag';

const resource = {
  icon: TagIcon,
}
  
export default resource
